import React, { useEffect, useState } from 'react';
import {
    HashRouter as Router,
    Route,
    Switch,
    RouteProps,
    // Link,
    useHistory,
    Redirect,
    useLocation,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { getCookie } from '@utiljs/cookie';
import { getProtocolStatus, PROTOCOL_STATUS, getMarginAccountStatus } from '@/services';
import urlUtil, { isCreator, isOutCustomerService, isMenuGray } from '@/utils/url';
import { permissionRequired } from '@/components/Permission';
import { getResources } from './config';

// 账户设置
import Account from './pages/Account';

// 评价管理
import Evaluation from './pages/Evaluation';

// 导航栏布局
import Layout from './pages/Layout';
// 物流管理
import FreightList from './pages/Freight';
import AddFreight from './pages/Freight/addFreight';
import AddSendGoods from './pages/Freight/addSendGoods';
// 直播管理
import LiveList from './pages/Live/list';
import LiveEditor from './pages/Live/editor';
// 客户管理
import ClientList from './pages/Client/list';
// 门店分配
import StoreList from './pages/StoreDistribute/index';
import DistributeRecord from './pages/Client/components/DistributeRecord';
// 代运营对账
import SettlementTP from './pages/SettlementTP/index';
// 体现详情
import AccountDetails from './pages/AccountDetails/index';
// 不是服务商
import NotProvider from './pages/NotProvider/index';
// 申请解约
import ContractCancel from './pages/ContractCancel/index';
// 得分状态
import Score from './pages/Score';

import V3Vue from './pages/V3Vue';
// 数据分析
import Analyse from './pages/dataAnalyse';

import Norm from './pages/Norm';
// 消息中心

import RefundDetails from './pages/RefundDetails';

import MessageCenter from './pages/MessageCenter';

import EpassportContinue from './pages/EpassportContinue';
// 消息内容
import MessageContent from './pages/MessageContent';
// 发票
import Invoice from './pages/Invoice';

// 服务管理
import ServiceList from './pages/ServiceList';
// 图文创作
import ImageCreate from './pages/ImageCreate';
// 视频创作
import VideoCreate from './pages/VideoCreate';
// 招募创作者
import AddCreator from './pages/AddCreator';
// 平台规则
import PlatformRule from './pages/PlatformRule';
import { AcctLoginTypeenums } from './pages/Client/api';

const env: any = process.env.APP_ENV;

function getHost() {
    const urlMap: any = {
        develop: 'http://platformproxy.waimai.dev.sankuai.com',
        qa: 'http://e.platform.proxy.b.waimai.test.sankuai.com',
        stage: 'https://proxy.waimai.st.sankuai.com',
        master: 'https://waimaieapp.meituan.com',
    };

    return urlMap[env] ? urlMap[env] : urlMap.master;
}

function isPageCanPass(history, toPath: string, passPages: string[]) {
    let isCreatorPage = false;
    passPages.forEach(item => {
        if (toPath.indexOf(item) !== -1) {
            isCreatorPage = true;
        }
    });

    // 无权限的页面重定向
    if (!isCreatorPage) history.push(passPages[0]);
}

const historyListener = (history, location) => {
    const isProvider = !urlUtil.commonParams.providerRole;
    const toPath = location.pathname;
    const whiteList = ['/notprovider', '/epassportcontinue'];
    let shouldCheck = true;
    whiteList.forEach(item => {
        if (toPath.indexOf(item) !== -1) {
            shouldCheck = false;
        }
    });
    if (shouldCheck && !isProvider && !isCreator && !isOutCustomerService) {
        // 不是服务商
        history.push('/notprovider');
    } else if (
        toPath.indexOf('/norm') === -1 &&
        toPath.indexOf('/login') === -1 &&
        toPath.indexOf('/notprovider') === -1
    ) {
        if (isCreator) {
            isPageCanPass(history, toPath, ['/imageCreate', '/videoCreate']);
        } else {
            // 判断是否同意过协议
            getProtocolStatus().then((data: any) => {
                if (data && data.data.isAgree === PROTOCOL_STATUS.unAgree) {
                    // 没有同意协议或接口异常
                    history.push('/norm');
                } else {
                    // 判断是否有保证金
                    getMarginAccountStatus()
                        .then(() => {
                            const passPages = [
                                '/main/v3/order',
                                '/evaluation',
                                '/messageCenter',
                                '/refundDetails',
                                '/contract/cancel',
                                '/messageContent',
                                '/platformRule',
                            ];
                            if (isOutCustomerService) {
                                isPageCanPass(history, toPath, passPages);
                            }
                        })
                        .catch(() => {
                            window.location.href = `${getHost()}/finance/common/pc/accountRecharge/rechargeToInfo?successCallback=${encodeURIComponent(
                                `${window.location.origin}/#${toPath}`,
                            )}&token=${getCookie('b_token')}&acctId=${getCookie(
                                'a_id',
                            )}&serviceProviderID=${getCookie(
                                'serviceProviderID',
                            )}&deviceUuid=${getCookie(
                                'device_uuid',
                            )}&_source=providerPC&acctType=1038`;
                        });
                }
            });
        }
    }
};

const HistoryListen: React.FC = props => {
    const history = useHistory();
    const location = useLocation();
    useEffect(() => {
        historyListener(history, location);
        const unlisten = history.listen(_location => {
            historyListener(history, _location);
        });
        return () => {
            unlisten();
        };
    });
    return <>{props.children}</>;
};

const routes: RouteProps[] = [
    {
        path: '/epassportcontinue',
        component: EpassportContinue,
    },
    {
        path: '/freight/list',
        component: FreightList,
        exact: true,
    },
    {
        path: '/freight/addFreight',
        component: AddFreight,
        exact: true,
    },
    {
        path: '/freight/addSendGoods',
        component: AddSendGoods,
        exact: true,
    },
    {
        path: '/live/list',
        component: LiveList,
        exact: true,
    },
    {
        path: '/live/edit',
        component: LiveEditor,
        exact: true,
    },
    {
        path: '/client/list',
        component: ClientList,
        exact: true,
    },
    {
        path: '/settlementTP',
        component: SettlementTP,
    },
    {
        path: '/accountDetails/:outId',
        component: AccountDetails,
    },
    {
        path: '/main/v3/:path',
        component: V3Vue,
    },
    {
        path: '/analyse',
        component: Analyse,
    },
    {
        path: '/norm',
        component: Norm,
    },
    {
        path: '/serviceList',
        component: ServiceList,
    },
    {
        path: '/messageCenter',
        component: MessageCenter,
    },
    {
        path: '/messageContent',
        component: MessageContent,
    },
    {
        path: '/account',
        component: Account,
    },
    {
        path: '/evaluation',
        component: permissionRequired(Evaluation),
    },
    {
        path: '/score',
        component: permissionRequired(Score),
    },
    //https://partner.waimai.meituan.com/#/contract/cancel
    {
        path: '/contract/cancel',
        component: ContractCancel,
    },
    {
        path: '/invoice',
        component: Invoice,
    },
    {
        path: '/refundDetails',
        component: RefundDetails,
    },
    {
        path: '/imageCreate',
        component: ImageCreate,
    },
    {
        path: '/videoCreate',
        component: VideoCreate,
    },
    {
        path: '/addCreator',
        component: AddCreator,
    },
    {
        path: '/platformRule',
        component: PlatformRule,
    },
    {
        path: '/distribute-record',
        component: DistributeRecord,
        exact: true, // 确保路径精确匹配
    },
];

let rootRouter;
switch (urlUtil.commonParams.acctLoginType) {
    case AcctLoginTypeenums.CREATOR:
        rootRouter = '/imageCreate';
        break;
    case AcctLoginTypeenums.OUT_CUSTOMER_SERVICE:
        rootRouter = '/main/v3/order';
        break;
    default:
        rootRouter = '/serviceList';
        break;
}

const RouterConfig = () => (
    <Router>
        <HistoryListen>
            <Switch>
                <Route
                    path="/"
                    render={() => (
                        <Layout>
                            <Route path="/notprovider" component={NotProvider} />
                            <Redirect from="/" to={rootRouter} exact />
                            <Redirect from="/main/list" to={rootRouter} exact />
                            <Redirect from="/main/v3/list" to={rootRouter} exact />

                            <>
                                {routes.map((props: RouteProps, index) => (
                                    <Route key={`${props.path}_${index}`} {...props} />
                                ))}
                            </>
                        </Layout>
                    )}
                />
            </Switch>
        </HistoryListen>
    </Router>
);

const grayHistoryListener = (history, location) => {
    const toPath = location.pathname;
    if (toPath.indexOf('/norm') === -1 && toPath.indexOf('/login') === -1) {
        if (isCreator) {
            isPageCanPass(history, toPath, ['/imageCreate', '/videoCreate']);
        } else {
            // 判断是否同意过协议
            getProtocolStatus().then((data: any) => {
                if (data && data.data.isAgree === PROTOCOL_STATUS.unAgree) {
                    // 没有同意协议或接口异常
                    history.push('/norm');
                } else {
                    // 判断是否有保证金
                    getMarginAccountStatus()
                        .then(() => {
                            console.info('Deposit paid');
                        })
                        .catch(() => {
                            window.location.href = `${getHost()}/finance/common/pc/accountRecharge/rechargeToInfo?successCallback=${encodeURIComponent(
                                `${window.location.origin}/#${toPath}`,
                            )}&token=${getCookie('b_token')}&acctId=${getCookie(
                                'a_id',
                            )}&serviceProviderID=${getCookie(
                                'serviceProviderID',
                            )}&deviceUuid=${getCookie(
                                'device_uuid',
                            )}&_source=providerPC&acctType=1038`;
                        });
                }
            });
        }
    }
};

const GaryHistoryListen: React.FC = props => {
    const history = useHistory();
    const location = useLocation();
    useEffect(() => {
        grayHistoryListener(history, location);
        const unlisten = history.listen(_location => {
            grayHistoryListener(history, _location);
        });
        return () => {
            unlisten();
        };
    });
    return <>{props.children}</>;
};

const routeMapping: Record<string, RouteProps | Record<string, RouteProps>> = {
    evaluation: { path: '/evaluation', component: Evaluation, exact: true },
    manage: { path: '/serviceList', component: ServiceList },
    freight: {
        list: { path: '/freight/list', component: FreightList, exact: true },
        addFreight: { path: '/freight/addFreight', component: AddFreight, exact: true },
        addSendGoods: { path: '/freight/addSendGoods', component: AddSendGoods, exact: true },
    },
    live: {
        liveList: { path: '/live/list', component: LiveList, exact: true },
        editor: { path: '/live/edit', component: LiveEditor, exact: true },
    },
    client: { path: '/client/list', component: ClientList, exact: true },
    store: { path: '/store/list', component: StoreList, exact: true },
    settlementTP: {
        settlementThirdParty: { path: '/settlementTP', component: SettlementTP },
        invoice: {
            path: '/invoice',
            component: Invoice,
        },
    },
    accountdetails: { path: '/accountDetails/:outId', component: AccountDetails },
    analyse: { path: '/analyse', component: Analyse },
    norm: { path: '/norm', component: Norm },
    messageCenter: {
        message: {
            path: '/messageCenter',
            component: MessageCenter,
        },
        messagecontent: {
            path: '/messageContent',
            component: MessageContent,
        },
        contract: {
            path: '/contract/cancel',
            component: ContractCancel,
        },
        refundDetails: {
            path: '/refundDetails',
            component: RefundDetails,
        },
    },
    score: {
        path: '/score',
        component: permissionRequired(Score),
    },
    order: {
        path: '/refundDetails',
        component: RefundDetails,
    },
    addCreator: {
        path: '/addCreator',
        component: AddCreator,
    },
    platformRule: {
        path: '/platformRule',
        component: PlatformRule,
    },
};

const renderRoutes = (
    routeKeys: any[], // `routes` 的值是一个路由键的数组
    routeMapping: Record<string, RouteProps | Record<string, RouteProps>>, // 路由映射表
    pathSet = new Set(),
) => {
    const res = routeKeys
        .map((key, index) => {
            const value = routeMapping[key]; // 根据键从 `routeMapping` 中取值
            if (!value) {
                // 过滤掉菜单的父MenuCode
                return null;
            }

            if ('path' in value) {
                if (!pathSet.has(value.path)) {
                    pathSet.add(value.path);
                    // 如果是直接的 `RouteProps`，渲染路由
                    return <Route key={`${key}_${index}`} {...(value as RouteProps)} />;
                }
            } else {
                // 如果是嵌套对象，递归渲染内部路由
                const nestedKeys = Object.keys(value);
                return renderRoutes(nestedKeys, value as Record<string, RouteProps>, pathSet);
            }
        })
        .filter(Boolean) // 过滤掉 null
        .flat(); // 展平数组
    return res;
};

const commonRoutes: RouteProps[] = [
    {
        path: '/norm',
        component: Norm,
    },
    {
        path: '/account',
        component: Account,
    },
    {
        path: '/main/v3/:path',
        component: V3Vue,
    },
    { path: '/epassportcontinue', component: EpassportContinue },
    {
        path: '/imageCreate',
        component: ImageCreate,
    },
    {
        path: '/videoCreate',
        component: VideoCreate,
    },
];

const GrayRouterConfig = () => {
    const [routes, setRoutes] = useState<any[]>([]);
    useEffect(() => {
        getResources()
            .then(res => {
                if (res.length === 0) {
                    return;
                } else {
                    setRoutes(res);
                }
            })
            .catch(error => {
                console.warn(error);
            });
    });
    return (
        <Router>
            <GaryHistoryListen>
                <Switch>
                    <Route
                        path="/"
                        render={() => (
                            <Layout>
                                <>
                                    {commonRoutes.map((props: RouteProps, index) => (
                                        <Route key={`${props.path}_${index}`} {...props} />
                                    ))}

                                    {renderRoutes(routes, routeMapping)}
                                </>
                            </Layout>
                        )}
                    />
                </Switch>
            </GaryHistoryListen>
        </Router>
    );
};

const mapDispatchToProps = (dispatch: any) => ({
    setProviderData: (data: any) => {
        const type = 'provider/update';
        return dispatch({
            type,
            payload: {
                user: data,
            },
        });
    },
});

const mapStateToProps = (state: any) => ({
    userData: state.provider.user,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(isMenuGray ? GrayRouterConfig : RouterConfig);
